import {
    Status,
    Step,
} from "@amzn/d16-g-client-deck-builder-typescript-client";

import { Progress } from "../types/progress";

export const getCardProgress = (step: Step, status: Status): Progress => {
    if (step === Step.VISUALIZATION && status === Status.FAIL) {
        return Progress.VISUALIZATION_FAILED;
    }

    if (step === Step.VISUALIZATION && status === Status.WARNING) {
        return Progress.VISUALIZATION_WARNING;
    }

    if (step === Step.ARTIFACTS_GENERATION && status === Status.FAIL) {
        return Progress.ARTIFACTS_GENERATION_FAILED;
    }

    if (step === Step.FORGE_VISUALIZATION && status === Status.FAIL) {
        return Progress.VISUALIZATION_FAILED;
    }

    return Progress.SUCCESS;
};
